<script>
import axios from '@/utils/axios';
import { pincodeWiseAddress } from '@/utils/admin';

export default {
  inject: ['setLoading'],
  data() {
    return {
      errors: {},
      step: 1,
      viewMode: false,
      id: '',
      code: '',
      name: '',
      address: '',
      city: '',
      state: '',
      country: '',
      pincode: '',
      status: 'active',
      subtotal: 0,
      tax_amount: 0,
      total: 0,
      items_dropdown: [],
      brands_dropdown: [],
      items: [
        { brand_id: null, item_id: null, items_list: [], allocated_quantity: 1, unit_price: 0, tax_id: null }
      ],
      module_url: 'work-orders'
    };
  },

  methods: {

    async loadDropdowns() {
      try {
        const [brandRes] = await Promise.all([
          axios.get('/brands/dropdown'),
        ]);
        this.brands_dropdown = brandRes.data.data || [];
      } catch (error) {
        console.log('Dropdown load error:', error.message);
      }
    },

    async onBrandSelect(index, brandId) {
      const row = this.items[index];
      row.brand_id = brandId;
      row.item_id = null;
      row.unit_price = 0;
      row.tax_id = null;
      row.items_list = [];

      if (!brandId) return;

      try {
        const response = await axios.get(`/items/${brandId}/brand-wise`);
        row.items_list = response.data.data || [];
      } catch (error) {
        this.$swalToast('Failed to load items for selected brand', 'error');
      }
    },

      onItemSelect(index, itemId) {
      const row = this.items[index];
      if (!itemId) {
        row.item_id = null;
        row.unit_price = 0;
        row.tax_id = null;
        return;
      }
      const product = row.items_list.find(p => p.id === itemId);
      if (product) {
        row.unit_price = parseFloat(product.price || 0);
        row.tax_id = product.tax_id || null;
      }
    },

    // ========== PINCODE AUTO-FILL ==========
    checkPincode() {
      if (this.pincode.length < 6) {
        this.errors.pincode = ["The pincode field must be 6 digits."];
      } else {
        delete this.errors.pincode;
        clearTimeout(this.pincodeTimeout);
        this.pincodeTimeout = setTimeout(() => {
          this.addressByPincode();
        }, 500);
      }
    },

    async addressByPincode() {
      this.setLoading(true);
      try {
        const response = await pincodeWiseAddress(this.pincode);
        const data = response.data.data;
        if (data?.city)    this.city    = data.city;
        if (data?.state)   this.state   = data.state;
        if (data?.country) this.country = data.country;
      } catch (error) {
        console.log('Pincode lookup failed:', error.message);
      } finally {
        this.setLoading(false);
      }
    },
    // ========== END PINCODE ==========

async viewWorkOrder(row) {
  await this.openWorkOrder(row);
  this.viewMode = true; 
},

    async openWorkOrder(row = null) {
  this.resetForm();
  await this.loadDropdowns();

  if (row !== null) {
    this.setLoading(true);
    try {
      const response = await axios.get(`/${this.module_url}/${row.id}`);
      const data = response.data.data;
      this.id       = data.id;
      this.code     = data.code;
      this.name     = data.name;
      this.address  = data.address;
      this.city     = data.city;
      this.state    = data.state;
      this.country  = data.country;
      this.pincode  = data.pincode;
      this.status   = data.status;
      this.subtotal = data.subtotal;
      this.tax_amount = data.tax_amount;
      this.total    = data.total;

      if (data.work_order_items && data.work_order_items.length) {
        this.items = data.work_order_items.map(item => ({
          brand_id: item.item?.brand_id || null,
          item_id: item.item_id,
          items_list: [],
          allocated_quantity: item.allocated_quantity,
          available_quantity: item.available_quantity,
          unit_price: parseFloat(item.unit_price),
          tax_id: item.tax_id,
        }));

        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].brand_id) {
            try {
              const res = await axios.get(`/items/${this.items[i].brand_id}/brand-wise`);
              this.items[i].items_list = res.data.data || [];
            } catch (e) {
              console.log('Brand items load error:', e.message);
            }
          }
        }
      }
    } catch (error) {
      this.$swalToast(error.message, 'error');
    } finally {
      this.setLoading(false);
    }
  }
},

    nextStep() {
      if (!this.name)    { this.$swalToast('Please enter work order name', 'error'); return; }
      if (!this.address) { this.$swalToast('Please enter address', 'error'); return; }
      if (!this.city)    { this.$swalToast('Please enter city', 'error'); return; }
      this.step = 2;
    },

    prevStep() { this.step = 1; },

    addItem() {
      this.items.push({ brand_id: null, item_id: null, items_list: [], allocated_quantity: 1, unit_price: 0, tax_id: null });
    },

    removeItem(index) {
      if (this.items.length > 1) this.items.splice(index, 1);
    },

    async saveWorkOrder() {
      this.errors = {};
      this.setLoading(true);
      try {
        const payload = {
          name: this.name,
          address: this.address,
          city: this.city,
          state: this.state,
          country: this.country,
          pincode: this.pincode,
          items: this.items.map(item => ({
            item_id: item.item_id,
            allocated_quantity: item.allocated_quantity,
            unit_price: item.unit_price,
            tax_id: item.tax_id,
          })),
        };

        let response;
        if (this.id) {
          response = await axios.put(`/${this.module_url}/${this.id}`, payload);
        } else {
          response = await axios.post(`/${this.module_url}`, payload);
        }

        this.$swalToast(response.data.message);
        this.$emit('updated');
        this.$closeModal('work_order_modal');
        this.resetForm();
      } catch (error) {
        if (error.type == 'validation' && typeof error.errors === 'object') {
          this.errors = error.errors;
          const step1Fields = ['name', 'address', 'city', 'state', 'country', 'pincode'];
          if (step1Fields.some(f => this.errors[f])) this.step = 1;
        } else if (error.type == 'validation' && typeof error.errors === 'string') {
          this.$swalToast(error.errors, 'error');
        } else {
          this.$swalToast(error.message, 'error');
        }
      } finally {
        this.setLoading(false);
      }
    },

    formatCurrency(val) {
      return parseFloat(val || 0).toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
    },

    resetForm() {
      this.step = 1;
      this.viewMode = false;
      this.id = ''; this.code = ''; this.name = '';
      this.address = ''; this.city = ''; this.state = '';
      this.country = ''; this.pincode = ''; this.status = 'active';
      this.subtotal = 0; this.tax_amount = 0; this.total = 0;
      this.errors = {};
      this.items = [{ brand_id: null, item_id: null, items_list: [], allocated_quantity: 1, available_quantity: 0, unit_price: 0, tax_id: null }];
    },

  },
};
</script>

<template>

  <div class="modal fade" id="work_order_modal">
    <div class="modal-dialog modal-dialog-centered modal-lg w-100">
      <div class="modal-content" style="border:none;border-radius:14px;overflow:hidden;">

        <div class="modal-header" style="background:#f8f9fb;border-bottom:1px solid #f0f1f5;padding:16px 20px;">
          <div style="display:flex;align-items:center;gap:10px;">
            <span style="display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;background:#fff0f0;border-radius:8px;">
              <i class="ti ti-clipboard-list" style="font-size:17px;color:#e84040;"></i>
            </span>
            <h4 class="modal-title" style="font-size:15px;font-weight:600;margin:0;color:#1a1d23;">
              {{ viewMode ? 'View' : (id ? 'Edit' : 'Add') }} Work Order
              <span v-if="viewMode && code" style="font-size:12px;color:#9e9e9e;font-weight:400;margin-left:6px;">{{ code }}</span>
            </h4>
            <div v-if="!viewMode" style="display:flex;align-items:center;gap:6px;margin-left:12px;">
              <span style="width:24px;height:24px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;"
                :style="step===1?'background:#e84040;color:#fff;':'background:#e8eaf0;color:#5a6272;'">1</span>
              <span style="width:20px;height:2px;background:#e8eaf0;"></span>
              <span style="width:24px;height:24px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;"
                :style="step===2?'background:#e84040;color:#fff;':'background:#e8eaf0;color:#5a6272;'">2</span>
            </div>
          </div>
          <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>

        <form @submit.prevent="saveWorkOrder">
          <div class="modal-body" style="padding:16px;background:#fff;max-height:75vh;overflow-y:auto;">

            <!-- ===== STEP 1 ===== -->
            <div v-show="step === 1 || viewMode">

              <div style="font-size:11px;font-weight:700;color:#b0b7c3;text-transform:uppercase;letter-spacing:0.6px;margin-bottom:12px;">
                Work Order Information
              </div>

              <div class="row g-3 mb-1">
                <div class="col-md-8">
                  <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">
                    Work Order Name <span v-if="!viewMode" class="text-danger">*</span>
                  </label>
                  <input type="text" class="form-control" v-model="name" :disabled="viewMode"
                    style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                  <div v-if="errors.name" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;">
                    <i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.name[0] }}
                  </div>
                </div>

                <!-- PINCODE -->
                <div class="col-md-4">
                  <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">
                    Pincode
                  </label>
                  <input type="text" class="form-control" v-model="pincode" maxlength="6" :disabled="viewMode"
                    @keyup="checkPincode"
                    style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                  <div v-if="errors.pincode" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;">
                    <i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.pincode[0] }}
                  </div>
                </div>
              </div>

              <div class="row g-3 mt-1 mb-1">
                <div class="col-md-12">
                  <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">
                    Street Address <span v-if="!viewMode" class="text-danger">*</span>
                  </label>
                  <input type="text" class="form-control" v-model="address" :disabled="viewMode"
                    style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                  <div v-if="errors.address" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;">
                    <i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.address[0] }}
                  </div>
                </div>
              </div>

              <!-- City, State, Country — pincode se auto fill honge -->
              <div class="row g-3 mt-1">
                <div class="col-md-4">
                  <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">
                    City <span v-if="!viewMode" class="text-danger">*</span>
                  </label>
                  <input type="text" class="form-control" v-model="city" :disabled="viewMode"
                    style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;"
                    placeholder="Auto-filled from pincode" />
                  <div v-if="errors.city" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;">
                    <i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.city[0] }}
                  </div>
                </div>
                <div class="col-md-4">
                  <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">
                    State
                  </label>
                  <input type="text" class="form-control" v-model="state" :disabled="viewMode"
                    style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;"
                    placeholder="Auto-filled from pincode" />
                  <div v-if="errors.state" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;">
                    <i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.state[0] }}
                  </div>
                </div>
                <div class="col-md-4">
                  <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">
                    Country
                  </label>
                  <input type="text" class="form-control" v-model="country" :disabled="viewMode"
                    style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;"
                    placeholder="Auto-filled from pincode" />
                  <div v-if="errors.country" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;">
                    <i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.country[0] }}
                  </div>
                </div>
              </div>

            </div>
            <!-- /STEP 1 -->

            <!-- ===== STEP 2 ===== -->
            <div v-show="step === 2 || viewMode">

              <!-- Summary Bar (hide in viewMode since info already visible above) -->
              <div v-if="!viewMode" style="background:linear-gradient(135deg,#fafbff 0%,#f4f6fb 100%);border:1px solid #e4e8f1;border-left:3px solid #e84040;border-radius:10px;padding:14px 16px;margin-bottom:16px;">
                <div style="font-size:10px;font-weight:700;color:#b0b7c3;text-transform:uppercase;letter-spacing:0.6px;margin-bottom:10px;">
                  Work Order Summary
                </div>
                <div style="display:flex;flex-wrap:wrap;gap:10px;">
                  <div style="flex:1;min-width:150px;background:#fff;border:1px solid #eef0f6;border-radius:8px;padding:10px 12px;display:flex;align-items:center;gap:8px;">
                    <span style="display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;background:#fff0f0;border-radius:6px;">
                      <i class="ti ti-clipboard-list" style="font-size:14px;color:#e84040;"></i>
                    </span>
                    <div style="overflow:hidden;">
                      <span style="font-size:10px;color:#9e9e9e;text-transform:uppercase;letter-spacing:0.4px;display:block;">Name</span>
                      <span style="font-size:13px;font-weight:600;color:#1a1d23;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;">{{ name || '-' }}</span>
                    </div>
                  </div>
                  <div style="flex:1;min-width:120px;background:#fff;border:1px solid #eef0f6;border-radius:8px;padding:10px 12px;display:flex;align-items:center;gap:8px;">
                    <span style="display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;background:#f0faf0;border-radius:6px;">
                      <i class="ti ti-map-pin" style="font-size:14px;color:#22c55e;"></i>
                    </span>
                    <div>
                      <span style="font-size:10px;color:#9e9e9e;text-transform:uppercase;letter-spacing:0.4px;display:block;">City</span>
                      <span style="font-size:13px;font-weight:600;color:#1a1d23;">{{ city || '-' }}</span>
                    </div>
                  </div>
                  <div style="flex:2;min-width:180px;background:#fff;border:1px solid #eef0f6;border-radius:8px;padding:10px 12px;display:flex;align-items:center;gap:8px;">
                    <span style="display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;background:#fef9ee;border-radius:6px;">
                      <i class="ti ti-home" style="font-size:14px;color:#f59e0b;"></i>
                    </span>
                    <div style="overflow:hidden;">
                      <span style="font-size:10px;color:#9e9e9e;text-transform:uppercase;letter-spacing:0.4px;display:block;">Address</span>
                      <span style="font-size:13px;font-weight:600;color:#1a1d23;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;">{{ address || '-' }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Divider for viewMode -->
              <div v-if="viewMode" style="border-top:1px solid #f0f1f5;margin:16px 0;"></div>

              <!-- Items Table -->
              <div style="font-size:11px;font-weight:700;color:#b0b7c3;text-transform:uppercase;letter-spacing:0.6px;margin-bottom:12px;display:flex;align-items:center;justify-content:space-between;">
                <span>Items</span>
                <a v-if="!viewMode" href="javascript:void(0);" @click="addItem" style="font-size:12px;color:#e84040;font-weight:600;text-decoration:none;">
                  <i class="ti ti-plus me-1"></i>Add Item
                </a>
              </div>

              <div v-if="errors.items" style="color:#e84040;font-size:11.5px;margin-bottom:8px;display:flex;align-items:center;gap:4px;">
                <i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.items[0] }}
              </div>

              <div class="table-responsive">
                <table class="table table-sm" style="font-size:13px;">
                  <thead>
                    <tr style="background:#f8f9fb;">
                      <th style="font-size:11px;font-weight:600;padding:8px;min-width:150px;">Brand</th>
                      <th style="font-size:11px;font-weight:600;padding:8px;min-width:180px;">Item</th>
                      <th style="font-size:11px;font-weight:600;padding:8px;min-width:80px;">Allocated Qty</th>
                      <th v-if="viewMode" style="font-size:11px;font-weight:600;padding:8px;min-width:80px;">Available Qty</th>
                      <th style="font-size:11px;font-weight:600;padding:8px;width:120px;min-width:90px;">Unit Price</th>
                      <th v-if="!viewMode" style="font-size:11px;font-weight:600;padding:8px;width:40px;"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in items" :key="index">
                      <td style="padding:6px;">
                        <vue-select :options="brands_dropdown" label="name" v-model="item.brand_id"
                          :reduce="b => b.id" placeholder="Select Brand" class="select-sm"
                          :disabled="viewMode"
                          @update:modelValue="onBrandSelect(index, $event)" />
                      </td>
                      <td style="padding:6px;">
                        <vue-select :options="item.items_list" label="name" v-model="item.item_id" :get-option-label="i => `${i.name} - ${i.code ?? i.id}`"
                          :reduce="p => p.id" placeholder="Select Item" class="select-sm"
                          :disabled="viewMode || !item.brand_id"
                          @update:modelValue="onItemSelect(index, $event)" />
                        <div v-if="errors[`items.${index}.item_id`]" style="color:#e84040;font-size:10.5px;margin-top:2px;">
                          {{ errors[`items.${index}.item_id`][0] }}
                        </div>
                      </td>
                      <td style="padding:6px;">
                        <input type="number" class="form-control form-control-sm" v-model="item.allocated_quantity" min="1"
                          :disabled="viewMode"
                          style="font-size:12px;border:1.5px solid #e8eaf0;border-radius:6px;background:#fafafa;" />
                      </td>
                      <td v-if="viewMode" style="padding:6px;">
                        <input type="number" class="form-control form-control-sm" 
                          v-model="item.available_quantity" min="0"
                          :disabled="viewMode"
                          style="font-size:12px;border:1.5px solid #e8eaf0;border-radius:6px;background:#fafafa;" />
                      </td>
                      <td style="padding:6px;">
                        <input type="number" class="form-control form-control-sm" v-model="item.unit_price" min="0" step="0.01"
                          :disabled="viewMode"
                          style="font-size:12px;border:1.5px solid #e8eaf0;border-radius:6px;background:#fafafa;" />
                      </td>
                      <td v-if="!viewMode" style="padding:6px;text-align:center;">
                        <a v-if="items.length > 1" href="javascript:void(0);" @click="removeItem(index)" style="color:#e84040;font-size:16px;">
                          <i class="ti ti-trash"></i>
                        </a>
                      </td>
                    </tr>
                    <div v-if="!viewMode" style="min-height:100px;"></div>
                  </tbody>
                </table>
              </div>

              <!-- Totals in viewMode -->
              <div v-if="viewMode && (subtotal || tax_amount || total)" style="border-top:1px solid #f0f1f5;margin-top:12px;padding-top:12px;">
                <div style="display:flex;justify-content:flex-end;">
                  <div style="min-width:220px;">
                    <div style="display:flex;justify-content:space-between;padding:4px 0;font-size:12px;color:#5a6272;">
                      <span>Subtotal</span>
                      <span style="font-weight:600;">{{ formatCurrency(subtotal) }}</span>
                    </div>
                    <div style="display:flex;justify-content:space-between;padding:4px 0;font-size:12px;color:#5a6272;">
                      <span>Tax</span>
                      <span style="font-weight:600;">{{ formatCurrency(tax_amount) }}</span>
                    </div>
                    <div style="display:flex;justify-content:space-between;padding:6px 0;font-size:13px;font-weight:700;color:#1a1d23;border-top:2px solid #e8eaf0;margin-top:4px;">
                      <span>Total</span>
                      <span>{{ formatCurrency(total) }}</span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <!-- /STEP 2 -->

          </div>

          <div class="modal-footer" style="background:#f8f9fb;border-top:1px solid #f0f1f5;padding:14px 20px;gap:8px;">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal"
              style="font-size:13px;border-radius:8px;padding:8px 18px;border:1.5px solid #e8eaf0;">
              {{ viewMode ? 'Close' : 'Cancel' }}
            </button>
            <template v-if="!viewMode">
              <button v-if="step === 1" type="button" class="btn btn-primary" @click="nextStep"
                style="font-size:13px;border-radius:8px;padding:8px 22px;background:#e84040;border:none;font-weight:500;">
                Next <i class="ti ti-arrow-right ms-1"></i>
              </button>
              <template v-if="step === 2">
                <button type="button" class="btn btn-outline-secondary" @click="prevStep"
                  style="font-size:13px;border-radius:8px;padding:8px 18px;">
                  <i class="ti ti-arrow-left me-1"></i> Back
                </button>
                <button type="submit" class="btn btn-primary"
                  style="font-size:13px;border-radius:8px;padding:8px 22px;background:#e84040;border:none;font-weight:500;">
                  {{ id ? 'Update' : 'Save' }} Work Order
                </button>
              </template>
            </template>
          </div>
        </form>

      </div>
    </div>
  </div>

</template>